import { Api, TonApiClient } from "@ton-api/client";
import { ContractAdapter } from "@ton-api/ton-adapter";

import { config } from "@/services/config";

const httpClient = new TonApiClient({
  baseUrl: config.ton.nodeUrl,
  baseApiParams: {
    headers: {
      Authorization: `Bearer ${config.ton.apiKey}`,
      "Content-type": "application/json",
    },
  },
});

export const publicClient = new Api(httpClient);
export const contractAdapter = new ContractAdapter(publicClient);
